import {useQueryParams} from '@aboutyou/router';
import {useRef} from 'react';
import {useIsCrmCouponsEnabled} from './useIsCrmCouponsEnabled';
import {CRM_COUPON_TOKEN_PARAM} from './utils/crmCouponTokenParam';

export const useCrmCouponTokenParam = () => {
  const isCrmCouponsEnabled = useIsCrmCouponsEnabled();
  const crmCouponToken = useQueryParams().get(CRM_COUPON_TOKEN_PARAM);

  return isCrmCouponsEnabled && crmCouponToken ? crmCouponToken : undefined;
};

export const useEntryUrlCrmCouponTokenParam = () => {
  const entryUrlCouponToken = useRef(useCrmCouponTokenParam()).current;
  return entryUrlCouponToken;
};
